import {colors, getStageMoments, getYStep} from '../utils';


// base class OY and OX axes
export class Axis extends PIXI.Container{
  constructor(App){
    super();

    this.zIndex = 1;
    this.App = App;
    this.graphics = new PIXI.Graphics();
    this.addChild(this.graphics);
  }

  render(){
    let App = this.App;
    let graphics = this.graphics;
    let moments = getStageMoments(App.startTimestamp, App.endTimestamp, App.renderer.width);
    let step;
    let maxValue = App.maxValue, minValue = App.minValue;

    graphics.clear();
    graphics.lineStyle(1, colors.grid, 0.05);

    // draws grid

    // draws OX lines
    for (let i = 0; i < moments.length; i++){
      let m = moments[i].moment;
      let x = App.getX(m.unix() * 1000);
      graphics.moveTo(x, App.renderer.height).lineTo(x, 0);
    }

    // draws OY lines
    step = getYStep(maxValue - minValue);
    let index = 0;
    for (let value = Math.floor((minValue - (maxValue - minValue) * 0.18) / step) * step;
         value <= maxValue + (maxValue - minValue) * 0.3; value += step){
      let y = App.getY(value) + App.chartPosition.top;
      graphics.moveTo(0, y);
      graphics.lineTo(App.renderer.width/App.devicePixelRatio, y);
      index++;
    }
  }
}


export class AxisMarks extends PIXI.Container{
  constructor(App){
    super();

    this.zIndex = 3;
    this.App = App;
    this.graphics = new PIXI.Graphics();
    this.horizontalMarks = new PIXI.Container();
    this.verticalMarks = new PIXI.Container();


    let width = App.renderer.width/App.devicePixelRatio;
    let height = App.renderer.height/App.devicePixelRatio;

    this.verticalMarks.position.set(width - App.rightMargin + 25, App.chartPosition.top);

    this.quotes = App.quotes;

    // black background for marks
    let timeMask = new PIXI.Graphics();
    timeMask.isMask = true;

    timeMask.moveTo(width * 0.02, height * 0.975)
      .lineTo(width * 0.95, height * 0.975)
      .lineTo(width * 0.95, height)
      .lineTo(width * 0.02, height)
      .lineTo(width * 0.02, height * 0.975);

    this.horizontalMarks.mask = timeMask;

    this.graphics.beginFill(0x000000, 1).
      drawRect(width * 0.02, height * 0.975, width * 0.93, height).
      drawRect(width - App.rightMargin + 20, 20, width, height).
      endFill();

    this.addChild(timeMask, this.graphics, this.horizontalMarks, this.verticalMarks);
  }

  render(){
    let App = this.App;
    let moments = getStageMoments(App.startTimestamp, App.endTimestamp, App.renderer.width/App.devicePixelRatio);
    let step;
    let maxValue = App.maxValue, minValue = App.minValue;

    // In horizontalMarks container stored buffer of marks.
    this.horizontalMarks.children.forEach((c) => {c.visible = false});

    // creates additional markContainers for moments
    if (moments.length > this.horizontalMarks.children.length){
      let diff = moments.length - this.horizontalMarks.children.length;
      for (let i = 0; i < diff; i++){
        let txt = new PIXI.Text(gettext('value'));
        txt.position.y = (App.renderer.height/App.devicePixelRatio | 0 ) * 0.98;
        txt.style = {fontFamily: 'Dintext, Arial, Helvetica, sans-serif', fontSize: '10px', fill: colors.text, align: 'center'};
        this.horizontalMarks.addChild(txt);
      }
    }

    // draws horizontal marks
    for (let i = 0; i < moments.length; i++){
      let m = moments[i].moment;
      let x = App.getX(m.unix() * 1000);
      let text = this.horizontalMarks.children[i];
      if (text.text != m.format(moments[i].format)) {
        text.text = m.format(moments[i].format);
      }
      text.position.x = x - text.width / 2;
      text.visible = true;
    }

    // same as horizontal marks
    this.verticalMarks.children.forEach((c) => {c.visible = false});

    step = getYStep(maxValue - minValue);
    let index = 0;
    for (let value = Math.floor((minValue - (maxValue - minValue) * 0.18) / step) * step;
         value <= maxValue + (maxValue - minValue) * 0.3; value += step){
      let text;
      if (index < this.verticalMarks.children.length){
        text = this.verticalMarks.children[index];
      }
      else{
        text = new PIXI.Text(gettext('value'));
        text.style = {fontFamily: 'Dintext, Arial, Helvetica, sans-serif', fontSize: '10px', fill: colors.text};
        this.verticalMarks.addChild(text);
      }

      if (text.text != String(value)) {
        text.text = String(step).indexOf('.') != -1 ? value.toFixed(String(step).split('.')[1].length) : value;
      }
      text.position.y = App.getY(value) - text.height / 2;
      text.visible = true;
      index++;
    }
  }
}
